<dx-scroll-view>
  <div *ngIf="route" class="grid p-1 grid-cols-2 gap-1 history-metrics">
    <div
      title="Longeur du trajet"
      class="shadow-sm hover:shadow cursor-pointer"
    >
      <div class="metric-text">Longeur du trajet</div>
      <span class="metric-value"
        >{{ route?.lengthStr() }} <span class="metric-unit">km</span></span
      >
    </div>
    <div title="Vitesse Maximale" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Vitesse Maximale</div>
      <span class="metric-value"
        >{{ route?.top_speed }} <span class="metric-unit">km/h</span></span
      >
    </div>
    <div title="Vitesse Moyenne" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Vitesse Moyenne</div>
      <span class="metric-value"
        >{{ route?.avg_speed }} <span class="metric-unit">km/h</span></span
      >
    </div>
    <div title="Temps Mouvement" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Temps Mouvement</div>
      <span class="metric-value"
        >{{ route?.drivesDurationStr() }}
        <span class="metric-unit">h</span></span
      >
    </div>
    <div title="Temps d'arrêt" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Temps d'arrêt</div>
      <span class="metric-value"
        >{{ route?.stopsDurationStr() }}
        <span class="metric-unit">h</span></span
      >
    </div>
    <div title="Heures Moteur" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Heures Moteur</div>
      <span class="metric-value"
        >{{ route?.engineWorkTimeStr() }}
        <span class="metric-unit">h</span></span
      >
    </div>
    <div
      *ngIf="route.maximum_temperature"
      title="Température"
      class="shadow-sm hover:shadow cursor-pointer"
    >
      <div class="metric-text">Température</div>
      <div class="metric-text pt-1">Maximale</div>
      <span class="metric-value pt-0"
        >{{ route?.maximumTemperatureStr() }}
        <span class="metric-unit">°C</span></span
      >
      <div class="metric-text pt-1">Minimale</div>
      <span class="metric-value pt-0"
        >{{ route?.minimumTemperatureStr() }}
        <span class="metric-unit">°C</span></span
      >
    </div>
    <div
      *ngIf="route.maximum_humidity"
      title="Humidité"
      class="shadow-sm hover:shadow cursor-pointer"
    >
      <div class="metric-text">Humidité</div>
      <div class="metric-text pt-1">Maximale</div>
      <span class="metric-value pt-0"
        >{{ route?.maximumHumidityStr() }}
        <span class="metric-unit">%</span></span
      >
      <div class="metric-text pt-1">Minimale</div>
      <span class="metric-value pt-0"
        >{{ route?.minimumHumidityStr() }}
        <span class="metric-unit">%</span></span
      >
    </div>
    <div
      *ngIf="route.fuel_consumption"
      title="Carburant"
      class="shadow-sm hover:shadow cursor-pointer"
    >
      <div class="metric-text">Carburant</div>
      <span class="metric-value"
        >{{ route?.fuelConsumptionStr() }}
        <span class="metric-unit">L</span></span
      >
    </div>
    <div
      *ngIf="route.fuel_consumption"
      title="Consommation / Heure"
      class="shadow-sm hover:shadow cursor-pointer"
    >
      <div class="metric-text">Consommation / Heure</div>
      <span class="metric-value"
        >{{ route?.fuelConsumptionPerHourStr() }}
        <span class="metric-unit">L/h</span></span
      >
    </div>
    <div
      *ngIf="route.total_fuel_consumption"
      title="Carburant"
      class="shadow-sm hover:shadow cursor-pointer"
    >
      <div class="metric-text">Carburant</div>
      <span class="metric-value"
        >{{ route?.total_fuel_consumption.toFixed(2) }}
        <span class="metric-unit">L</span></span
      >
    </div>
    <div
      *ngIf="route.fuel_consumption_per_hour"
      title="Consommation / Heure"
      class="shadow-sm hover:shadow cursor-pointer"
    >
      <div class="metric-text">Consommation / Heure</div>
      <span class="metric-value"
        >{{ route?.fuel_consumption_per_hour.toFixed(2) }}
        <span class="metric-unit">L/h</span></span
      >
    </div>
  </div>
</dx-scroll-view>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.05)"
  [position]="{ of: host.nativeElement }"
  [visible]="isLoading"
  [showIndicator]="false"
  [showPane]="false"
  [shading]="true"
  [closeOnOutsideClick]="false"
>
</dx-load-panel>
